export interface MachineConnectivityPolicy {
    MachineConnectivityBehavior: MachineConnectivityBehavior;
}

export enum MachineConnectivityBehavior {
    ExpectedToBeOnline = "ExpectedToBeOnline",
    MayBeOfflineAndCanBeSkipped = "MayBeOfflineAndCanBeSkipped",
}

export default MachineConnectivityPolicy;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/machineConnectivityPolicy.ts